export enum PatternStatus {
  UpToDate = 'UpToDate',
  Deprecated = 'Deprecated',
  Outdated = 'Outdated',
  Experimental = 'Experimental',
  Unknown = 'Unknown',
}
